import { Controller } from '@hotwired/stimulus';

import { parseISO } from 'date-fns';

export default class CourseCompletionTestWaitingTimerController extends Controller {
  static values = {
    startTime: String
  };

  static targets = [
    'confirmed',
    'startButton'
  ];

  hasStarted = false;

  constructor() {
    super(...arguments);

    this.startTime = parseISO(this.startTimeValue);
  }

  tick({ detail: { now } }) {
    if (now >= this.startTime) {
      // 2科目目の待機画面にはチェックボックスがないので、存在しない場合はチェックされたものとして扱う
      if (!this.hasConfirmedTarget || this.confirmedTarget.checked) {
        this.startButtonTarget.disabled = false;

        // チェックした状態で開始時間を迎えた場合は自動的に遷移する
        if (!this.hasStarted) {
          this.startButtonTarget.click();
        }
      }

      this.hasStarted = true;
    }
  }

  toggleConfirmed() {
    if (this.confirmedTarget.checked && this.hasStarted) {
      this.startButtonTarget.disabled = false;
    } else {
      this.startButtonTarget.disabled = true;
    }
  }
}
